import type { LabRemoteConfigKeys } from 'constants/lab'
import { useAppSelector } from 'hooks/reduxHooks'

export const useLabRemoteConfig = (key: LabRemoteConfigKeys): App.LabRemoteConfigResult | undefined => {
  const remoteConfig = useAppSelector(state => state.system?.features?.remoteConfigFlags?.[key])
  return remoteConfig
}
